import { ButtonRounded, Tag, WContainer } from '@components/atoms'
import { Camion, Palette } from '@components/icons'
import { HeroModalSlide, CollezioneHeroSlide } from '@components/molecules'
import { GalleryModal, GenericSlider } from '@components/organisms'
import { useState } from 'react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper/types'
import styles from './CollezioneHero.module.sass'

interface Props {
  collezione?: any
  className?: string
}

export const heroSwiperParams: SwiperOptions = {
  slidesPerView: 1,
  modules: [Pagination, Navigation, A11y],
  pagination: {
    clickable: true,
  },
  navigation: true,
  breakpoints: {
    992: {
      spaceBetween: 64,
    },
  },
}

const CollezioneHero = (props: Props) => {
  const { collezione = undefined, className = '' } = props

  const [modalOpen, setModalOpen] = useState(false)

  return (
    !!collezione?.gallery?.length && (
      <div className={`${styles.root} ${className}`}>
        <WContainer>
          <GenericSlider
            notch
            navigationPos="middle"
            id={`hero_collezione_${collezione.id}`}
            conf={heroSwiperParams}
            className={styles.slider}
          >
            {collezione?.quickship ? (
              <Tag icon={<Camion />} label="Quickship" className={styles.camion} />
            ) : null}
            <ButtonRounded
              icon={<Palette />}
              mobileSize="xs"
              onClick={() => setModalOpen(true)}
              className={styles.palette}
            />
            {collezione.gallery.map((x, index) => (
              <SwiperSlide key={x.id}>
                <CollezioneHeroSlide item={x} index={index} />
              </SwiperSlide>
            ))}
          </GenericSlider>
        </WContainer>
        <GalleryModal
          id="hero_gallerymodal"
          items={collezione.gallery.map((x) => ({ pk: x.id, image: x.url }))}
          zoom
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          mainSwiperClassName={styles.modalMainSwiper}
        >
          {collezione.gallery.map((x) => (
            <SwiperSlide key={x.id}>
              <HeroModalSlide nomeCollezione={collezione?.nome} item={x} />
            </SwiperSlide>
          ))}
        </GalleryModal>
      </div>
    )
  )
}

export default CollezioneHero
